
import styled from 'styled-components'
const Container = styled.div`
    margin: 5em 0;
`
const Column = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    @media (max-width:1050px){
        display: flex;
        flex-direction: column;
        img{
            margin: 2em auto;
            width: 90%;
        }
    }
    @media (max-width:600px){
        img{
            margin-top: 0;
        }
    }
`
const Row = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 5em;
    justify-content: center;
    *{
        margin: .5em 0;
    }
    @media (max-width:600px){
        margin: 0 1em;
    }
`
const Highlight = styled.p`
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    /* identical to box height, or 34px */

    color: var(--bg-primary);
`
const Label = styled.h2`
    width: 524px;
    @media (max-width:1500px){
        width: 100%;
    }
`
function Community (props) {
  const { contents } = props
  return (
        <Container>
            <Column>
                {/* <img src="/media/about/community.png" alt="Community" /> */}
                <img src="/media/hero/community.png" style={{width: '508px', padding: '0 5px'}} alt="Community" />
                <Row>
                    <Highlight>{contents.aboutHeroHighlight}</Highlight>
                    {/* <Label>{contents.aboutHeroLabel}</Label> */}
                    <p> {contents.aboutHeroCaption} </p>
                </Row>
            </Column>
        </Container>
  )
}

export default Community
